import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler,
  CountryCityService
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { ClientAddressDO } from 'app/BaseFramework/shared/models'

@Component({
  selector: 'ui-address-thai',
  templateUrl: './ui-address-thailand.component.html',
  styleUrls: ['./ui-address-thailand.component.scss']
})
export class UIAddressThaiComponent implements OnInit {
  _currentComponentName = 'UIAddressThaiComponent'
  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private countryCityService: CountryCityService,
    private msg: NzMessageService) { }

  //Declaraions which might need developer input
  uiAddressThaiForm: FormGroup
  UIADDRESSINDFORMNAME = "uiAddressThaiForm"
  lookupsToBind = ['cityCd', 'stateCd', 'countryCd', 'addressTypeCd']
  selectorOfThisComponent = 'ui-address-thai'
  parentEvent$
  addressList: Array<any> = [];
  item

  list = [
    1, 2, 3
  ]
  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE 
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };

  private _disableDefaultCountryOnly: boolean = false;
  @Input()
  set disableDefaultCountryOnly(value: any) {
    if (value == null || value == undefined)
      this._disableDefaultCountryOnly = false
    else
      this._disableDefaultCountryOnly = value

  }

  get disableDefaultCountryOnly() {
    return this._disableDefaultCountryOnly
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let isOutputValid = this.validateOutput(this.uiAddressThaiForm)
      if (isOutputValid)
        this.EmitComponentOutput(this.uiAddressThaiForm)
      else {
        this.EmitComponentOutput("ERROR")
      }
    })
  }

  validateOutput(o: FormGroup) {
    this.commonUtilty.markAllFieldDirty(o);
    return o.valid
  }

  //Initializations
  lookup$: any = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  cityCd$: any = this.countryCityService.getProvinceCities(null)
  provinceSelected() {
    this.uiAddressThaiForm.controls['cityCd'].setValue(undefined)
    this.cityCd$ = this.countryCityService.getProvinceCities(this.uiAddressThaiForm.get('stateCd').value)
  }
  fetchProvinceandCityByPostCode() {
    this.countryCityService.getPostCodeProvince(this.uiAddressThaiForm.get('postCode').value).
      subscribe(resp => {
        if (resp && Array.isArray(resp) && resp.length > 0) {
          this.uiAddressThaiForm.controls['stateCd'].setValue(resp[0].stateCd);
          this.uiAddressThaiForm.controls['cityCd'].setValue(resp[0].cityCd);
        }
        else {
          this.msg.error("No Result found for entered Pincode/Postcode")
        }
      });
  }

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.initializeAddAddressForm(this._inputDataForEdit)
    this.subscribeToParentEvent()
    this.initializeAddressListEditMode()
  }

  initializeAddressListEditMode() {
    if (this._inputDataForEdit) {
      this.addressList = this._inputDataForEdit;
    }
  }

  /**
   * Form Trasactions
   */

  initializeAddAddressForm(data?, isEdit?, index?) {
    let payload = data || {}
    let countryCd
    if (!this.disableDefaultCountryOnly)
      countryCd = this.appMetadataHandler.currentCountryCd
    else
      countryCd = payload['countryCd']
    this.uiAddressThaiForm = this.fb.group({
      addressLine1: this.validationUtilService.setValidationsForFormControl('addressLine1', this.UIADDRESSINDFORMNAME, payload['addressLine1']),
      addressLine2: this.validationUtilService.setValidationsForFormControl('addressLine2', this.UIADDRESSINDFORMNAME, payload['addressLine2']),
      addressLine3: this.validationUtilService.setValidationsForFormControl('addressLine3', this.UIADDRESSINDFORMNAME, payload['addressLine3']),
      cityCd: this.validationUtilService.setValidationsForFormControl('cityCd', this.UIADDRESSINDFORMNAME, payload['cityCd']),
      postCode: this.validationUtilService.setValidationsForFormControl('postCode', this.UIADDRESSINDFORMNAME, payload['postCode']),
      isEdit: this.validationUtilService.setValidationsForFormControl('isEdit', this.UIADDRESSINDFORMNAME, isEdit),
      index: this.validationUtilService.setValidationsForFormControl('index', this.UIADDRESSINDFORMNAME, index),
      stateCd: this.validationUtilService.setValidationsForFormControl('stateCd', this.UIADDRESSINDFORMNAME, payload['stateCd']),
      countryCd: this.validationUtilService.setValidationsForFormControl('countryCd', this.UIADDRESSINDFORMNAME, countryCd),
      typeCd: this.validationUtilService.setValidationsForFormControl('typeCd', this.UIADDRESSINDFORMNAME, payload['typeCd']),
      id: this.validationUtilService.setValidationsForFormControl('id', this.UIADDRESSINDFORMNAME, payload['id']),
      prefferedFl: this.validationUtilService.setValidationsForFormControl('prefferedFl', this.UIADDRESSINDFORMNAME, payload['prefferedFl']),
      enableSearchByPinCode: this.validationUtilService.setValidationsForFormControl('enableSearchByPinCode', this.UIADDRESSINDFORMNAME)
    });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.UIADDRESSINDFORMNAME
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }
  addAddress() {
    if (this.uiAddressThaiForm.status === 'VALID') {
      let addressDO = new ClientAddressDO();

      if (this.uiAddressThaiForm.value.isEdit) {
        addressDO = this.addressList[this.uiAddressThaiForm.value.index];
      }

      addressDO.typeCd = this.uiAddressThaiForm.value.typeCd,
        addressDO.addressLine1 = this.uiAddressThaiForm.value.addressLine1;
      addressDO.addressLine2 = this.uiAddressThaiForm.value.addressLine2;
      addressDO.addressLine3 = this.uiAddressThaiForm.value.addressLine3;
      addressDO.stateCd = this.uiAddressThaiForm.value.stateCd;
      addressDO.countryCd = this.uiAddressThaiForm.value.countryCd;
      addressDO.postCode = this.uiAddressThaiForm.value.postCode;
      addressDO.cityCd = this.uiAddressThaiForm.value.cityCd;
      addressDO.id = this.uiAddressThaiForm.value.id;
      addressDO.prefferedFl = this.uiAddressThaiForm.value.prefferedFl;

      if (this.uiAddressThaiForm.value.isEdit) {
        this.addressList.splice(this.uiAddressThaiForm.value.index, 1, this.commonUtilty.deepCopy(addressDO))
      } else {
        this.addressList.push(this.commonUtilty.deepCopy(addressDO));
      }

      this.EmitComponentOutput(this.addressList)
      this.initializeAddAddressForm()
    }
  }

  editAddress(address, index) {
    let isEdit = true;
    this.initializeAddAddressForm(address, isEdit, index)
    this.cityCd$ = this.countryCityService.getProvinceCities(this.uiAddressThaiForm.get('stateCd').value)
  }

  removeAddress(address, index) {
    this.addressList.splice(index, 1)
    this.EmitComponentOutput(this.addressList)
  }

  clearForm() {
    this.initializeAddAddressForm()
  }

  enableSearchByPinCode
  enableDisableSearchByPin() {
    this.clearPinStateCity()
  }

  clearPinStateCity() {
    const fieldToNullify = ['postCode', 'stateCd', 'cityCd']
    fieldToNullify.forEach(e => this.uiAddressThaiForm.controls[e].setValue(null))
  }

  deselectOtherAddresssesPrefferedFl(priIndex) {
    this.addressList.forEach((element, index) => {
      if (priIndex != index) element.prefferedFl = false
    });
  }
}
